<top-navig [displayLogo]="false" displaySing="true"></top-navig>
<div class="home">
    <div class="banner-cell">
        <div class="row lg">
            <div class="col-md-12 typer">
                <img style="margin-top : 44px" src="assets/images/logo.png" width="200px" alt="logo">
                <div class="book-btn">
                    <a class="btn btn-order" href="javascript:void(0)" (click)="goToCarte()">
                        <img src="assets/images/addBasket.png" alt="commander">
                        <span>commander en ligne</span>
                    </a>
                </div>
                <div class="gradient-border" id="box" *ngIf="enablePayement">
                    <img src="assets/images/payement.png" alt="Paiement par carte bancaire">
                </div>
            </div>
        </div>

    </div>
</div>
<!-- <div id="about" class="about pad-top-100 pad-bottom-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s"
                    style="visibility: visible; animation-duration: 1s; animation-delay: 0.1s; animation-name: fadeIn;">
                    <h2 class="block-title"> À propos de nous </h2>
                    <div *ngIf="pdv?.comment" [innerHtml]="pdv?.comment" class="comment"></div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s"
                    style="visibility: visible; animation-duration: 1s; animation-delay: 0.1s; animation-name: fadeIn;">
                    <div class="about-images">
                        <img class="about-main" src="assets/images/about-main.jpg" alt="About Main Image">
                        <img class="about-inset" src="assets/images/about-inset.jpg" alt="About Inset Image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="offer-sec">
    <div class="container">
        <h1>Nos meilleurs offres</h1>
        <h3>Commandez... C'est livré</h3>
        <a routerLink="/carte" class="btn btn-danger btn-order btn-template">Découvrez nos meilleures offres</a>
    </div>
</div>
<div class="our-products">
    <h1 class="text-center">
        Nos Produits
    </h1>
</div>
<div>
    <products></products>
</div>